module.exports = __webpack_public_path__ + "media/competitions.2549068e.mp4";